import { CustomFields } from '~/commons/interfaces/models/common/CustomField'
import { Product } from '~/commons/interfaces/models/content/product/Product'

export function getProductCustomFields(product: Product): CustomFields {
  // @ts-ignore
  return product?.customFields || product?.translated?.customFields || {}
}
